import React from 'react';

const Loading = () => {
  return (
    <div className="loading">
      <div className="loading__state" />
      <div className="loading__state  loading__state--2" />
      <div className="loading__state  loading__state--3" />
      <div className="loading__state  loading__state--4" />
      <div className="loading__state  loading__state--5" />
    </div>
  );
};

export default Loading;



// WEBPACK FOOTER //
// ./src/components/Loading.js